module.exports = __webpack_public_path__ + "img/exterior-sample-2.550a4d2f.jpg";